import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  
  console.log('HTTP Request intercettata:', req.url); // AGGIUNGI QUESTO
  loadingService.show();

  return next(req).pipe(
    finalize(() => {
      console.log('HTTP Request terminata'); // AGGIUNGI QUESTO
      loadingService.hide();
    })
  );
};